/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ViewModel from "../../ViewModels/ViewModel";
import { fixedT, translationKeys } from "./../../Internationalisierung/i18nBasis";
import { useAppContext } from "./../AppContext";
import IAppContext from "./../AppContext/IAppContext";
import CloudBrowserRouterState from "./CloudBrowserRouterState";

export default class CloudBrowserRouterModel extends ViewModel<CloudBrowserRouterState> {
    private readonly _appContext: IAppContext;

    public constructor() {
        super({
            initialState: CloudBrowserRouterModel.getInitialState(),
        });
        this._appContext = useAppContext();
        window.onbeforeunload = this.beendeBrowser;
    }

    public get isOpen(): boolean {
        return this.state.isOpen;
    }

    public get dialogCaption(): string {
        return fixedT(translationKeys.cloudBrowserRouter.nichtGespeicherteAenderungen);
    }

    public get dialogText(): string {
        return this.state.dialogText;
    }

    public readonly getDialogText = (): any => {
        if (this._appContext.changeTracker.hasAnyChanges) {
            return fixedT(translationKeys.cloudBrowserRouter.moechtenSieDieAenderungenVerwerfen);
        }

        return true;
    };

    public readonly getUserConfirmation = (message: string, callback: (ok: boolean) => void) => {
        if (!this._appContext.changeTracker.hasAnyChanges) {
            callback(true);
        } else {
            this.setState((nextState) => {
                nextState.isOpen = true;
                nextState.callback = callback;
                nextState.dialogText = message;
            });
        }
    };


    public readonly speichern = async () => {
        try {
            let preventNavigate = false;
            await this._appContext.changeTracker.speichere({ preventNavigate: () => preventNavigate = true, navigateCallback: (confirm: boolean) => this.setResult(confirm) });
            if (!preventNavigate) {
                this.setResult(true);
            }
        } catch (e) {
            this.setResult(false);
            throw e;
        }
    }

    public readonly schliessen = () => {
        this.setResult(false);
    };

    public readonly verwerfen = () => {
        this.setResult(true);
    };

    private readonly beendeBrowser = (e: BeforeUnloadEvent) => {
        const dialogText = this.getDialogText();
        if (dialogText === true) {
            return;
        }

        e.returnValue = dialogText;
    };

    private setResult(result: boolean): void {
        this.state.callback(result);

        if (result) {
            this._appContext.changeTracker.clearAll();
        }

        this.setState((nextState) => {
            nextState.isOpen = false;
            nextState.dialogText = "";
            nextState.callback = () => {};
        });
    }

    private static getInitialState(): CloudBrowserRouterState {
        return {
            isOpen: false,
            callback: () => {},
            dialogText: "",
        };
    }
}
